import { createContext } from "react";

export const HeadingLevelContext = createContext(1);
